import { Link } from "react-router-dom";
// reactstrap components
import {
  NavbarBrand,
  Navbar,
  Container,
} from "reactstrap";

const AdminNavbar = () => {
  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark" expand="md">
        <Container >
          <NavbarBrand to="https://prosper.com.vc" tag={Link} target="_blank">
            <img
              alt="..."
              src={require("../../assets/img/brand/banner-prosper.png")}
              width="100px"
            />
          </NavbarBrand>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
